import React, { Component } from 'react'

import styles from './../StepColorSliderHandle.module.scss'

export class StepColorSecondary extends Component {
  render() {

    const { state, setSecondaryColor } = this.props   

    let secondaryColorSelected = '1'
    if (state && state.secondaryColorSelected) {
      secondaryColorSelected = state.secondaryColorSelected
    }     

    return (
      <div data-test="StepColorSecondaryComponent">
        <h6 className="text-uppercase font-weight-700 font-size-14px mb-4">Elige intensidad</h6>
        {state && state.colorsSecondary &&
          <div className={`${styles.rangeWrap} space-bottom`}>
            <input 
              className={styles.rangeInput} 
              onChange={(ev) => setSecondaryColor(ev)} 
              value={secondaryColorSelected} 
              type="range" 
              id="secondaryColorRange" 
              step="1" 
              min="0" 
              max={state.colorsSecondary.length - 1} />
              
            <div 
              className={styles.rangeColors} 
              style={{ background: `linear-gradient(to right, ${state.colorsSecondary.join(',')})` }}></div>
          </div>
        }
      </div>
    )

  }
  
}

export default StepColorSecondary
